import { GetApiData } from "utils/http-client";


export const GetAllSchool = function (page, limit, sortField, sortOrder, filters = {}) {
    const params = new URLSearchParams({ page, limit, sortField, sortOrder });

    Object.keys(filters).forEach((key) => {
        params.append(key, filters[key]);
    });

    return GetApiData(`/school?${params.toString()}`, 'GET', null, true);
}


export const CreateSchool = function (data) {
    return GetApiData(`/school`, 'POST', data, true);
}
export const CheckEmailStatus = function (data) {
    return GetApiData(`/school/check-admin-email`, 'POST', data, true);
}

export const AssignNewAdmin = function (data) {
    return GetApiData(`/school/add-new-admin`, 'POST', data, true);
}

export const AssignAdminExistingUser = function (data) {
    return GetApiData(`/school/add-existing-user-admin`, 'POST', data, true);
}

export const AddAdmin = function (data) {
    return GetApiData(`/school/add-admin`, 'POST', data, true);
}
export const resetAdminPassword = function (password, id) {
    console.log("Datat", password)
    return GetApiData(`/school/admin/${id}`, 'POST', { password }, true);
}
export const resetPassword = function (password, id) {
    console.log("Datat", password)
    return GetApiData(`/user/password-reset`, 'POST', { password, id }, true);
}
export const updateUserInfo = function (fullName, id) {
    // console.log("Datat", fullName)
    return GetApiData(`/user`, 'PUT', { fullName, id }, true);
}
export const deleteUser = async (id) => {
    return await GetApiData(`/user/${id}`, 'DELETE', null, true);
};
export const UpdateSchoolStatus = async (id, newStatus) => {
    return await GetApiData(`/school/status/${id}`, 'PUT', { status: newStatus }, true);
};
export const getSchoolDetail = async (id) => {
    return await GetApiData(`/school/${id}`, 'GET', null, true);
};
export const getAllPackages = async () => {
    return await GetApiData(`/package`, 'GET', null, true);
};
export const getSchoolStats = async (id) => {
    return await GetApiData(`/school/stats/${id}`, 'GET', null, true);
};
export const UpdateSchoolDetail = async (id, data) => {
    return await GetApiData(`/school/${id}`, 'PUT', data, true);
};
export const deleteSchool = async (id) => {
    return await GetApiData(`/school/${id}`, 'DELETE', null, true);
};

export const deleteStudent = async (id) => {
    return await GetApiData(`/school/student/${id}`, 'DELETE', null, true);
};